export enum FORMAT_DATE {
	PRESS_RELEASE = 'MMMM Do, YYYY',
}
